export default __webpack_public_path__ + "static/media/image-chair-child-w.120b6924.webp";